import { ASSISTANT_REPLY_RULES, ASSISTANT_FALLBACK_RULE } from '@/shared/constants/assistant';

// Pick the first reply whose keyword occurs in the question; padding keeps whole-word keywords such as ' hi ' exact.
export function matchAssistantReply(question) {
  const padded = ' ' + question.toLowerCase() + ' ';
  const rule = ASSISTANT_REPLY_RULES.find((entry) =>
    entry.keywords.some((keyword) => padded.includes(keyword)),
  );

  if (rule) {
    return rule;
  }
  return ASSISTANT_FALLBACK_RULE;
}

// A suggestion chip names its reply, so it also answers in languages other than English.
export function findAssistantReply(replyId) {
  const rule = ASSISTANT_REPLY_RULES.find((entry) => entry.reply === replyId);

  if (rule) {
    return rule;
  }
  return ASSISTANT_FALLBACK_RULE;
}
